export default __webpack_public_path__ + "static/media/BEAT-110-PREMIUM-1.0bf0f2eb.png";